import { AxiosResponse, InternalAxiosRequestConfig } from "axios"
import { firebaseauth } from "../../mp-database/firebaseConfig"

export const onRequest = async (config: InternalAxiosRequestConfig<any>) => {
  const token = await firebaseauth.currentUser.getIdToken(true)

  config.headers["Authorization"] = `Bearer ${token}`

  return config
}

export const onResponse = (response: AxiosResponse<any, any>) =>
  JSON.parse(response.data)
